import type { ApiClient } from './runtime/apiRuntime';
import { apiMutationOptions, BaseApiMutationOptions } from './apiMutationOptions';

export const UnsubscribeApi = {
    unsubscribe: (options?: BaseApiMutationOptions<ApiClient['unsubscribe']['unsubscribe']>) =>
        apiMutationOptions((api) => api.unsubscribe.unsubscribe, options),
    resubscribe: (options?: BaseApiMutationOptions<ApiClient['unsubscribe']['resubscribe']>) =>
        apiMutationOptions((api) => api.unsubscribe.resubscribe, options)
};
